export const TpaHandlerProviderSymbol = Symbol('TpaHandlerProvider')
